export const paginationOptions = {
  pageSize: 10,
  pageSizeOptions: [10, 25, 50, 100],
};

export const sortCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});
